import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SmartTagOrderItem, SmartTagSource } from 'src/app/interfaces/smart-tag';
import { STRIPE_CHECKOUT_ORIGIN } from 'src/app/constants/app.constants';
import { PaymentConfigService } from '../payment-config/payment-config.service';

@Injectable({
  providedIn: 'root',
})
export class CheckoutService {

  constructor(
    private http: HttpClient,
    private paymentConfigService: PaymentConfigService
  ) {}

  checkout(
    pricingPlanIds: string[],
    options?: {
      vetCode?: string,
      chipNumber?: string,
      petId?: number,
      isUpgrade?: boolean,
      cancelUrl?: string,
      smartTag?: {
        tags: SmartTagOrderItem[];
      }
    }
  ): Observable<void> {
    const { vetCode, chipNumber, petId, isUpgrade, smartTag, cancelUrl } = options || {};
    const priceIds = this.paymentConfigService.resolvePriceIds(pricingPlanIds);

    const body = smartTag
      ? {
        $type: 'smartTag',
        priceIds,
        tags: smartTag.tags,
        cancelUrl,
        source: SmartTagSource.Website
      }
      : {
        vetCode: vetCode ?? null,
        chipNumber: chipNumber ?? null,
        petId: petId ?? null,
        priceIds,
        cancelUrl,
        isUpgrade: isUpgrade ?? false
      }

    return this.http
      .post<{ sessionUrl: string }>(`${environment.apiUrl}/api/stripe/session`, body)
      .pipe(
        map(({ sessionUrl }) => {
          // redirect only to Stripe's hosted Checkout
          if (new URL(sessionUrl).origin !== STRIPE_CHECKOUT_ORIGIN) {
            throw new Error('Unexpected checkout URL');
          }
          window.location.href = sessionUrl;
        })
      );
  }

}
